import sha256 from 'crypto-js/sha256';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import CryptoJS from 'crypto-js';

export const ToTitleCase = (phrase) => {
    return phrase
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
  export default ToTitleCase;


export const separateNumber = (Number) =>{

  Number+= '';
  Number= Number.replace(',', '');
  var x = Number.split('.');
  var y = x[0];
  var z= x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(y))
  y = y.replace(rgx, '$1' + ',' + '$2');
  return y+ z;
}

export const GroupBy = (list, keyGetter)  => { 

  const map = new Map();

  list.forEach((item) => {

       const key = keyGetter(item);

       const collection = map.get(key);

       if (!collection) {

           map.set(key, [item]);

       } else {

           collection.push(item);

       }

  });

  return map;

}
export const Transpose = (data) => {
  let result = {};
  for (let row of data) {
    for (let [key, value] of Object.entries(row)) {
      result[key] = result[key] || [];
      result[key].push(value); 
    }
  }
  return result;
}

 
export const addComma = (str) => {
  str = removeComma(str);
  var objRegex = new RegExp('(-?[0-9]+)([0-9]{3})');

  while (objRegex.test(str)) {
      str = str.replace(objRegex, '$1,$2');
  }

  return str;
}

export const removeComma = (str) => {
  var myString = '',
      chrCode;

  for (var i = str.length - 1; i >= 0; --i) {
      chrCode = str.charCodeAt(i);

      // 44 = comma
      if (chrCode != 44) {
          myString = String.fromCharCode(chrCode) + myString;
      }

  }

  return myString;
}

export function ENC1(number) {

  var kyp = "11A1764225B11AA1";

  var key = CryptoJS.enc.Utf8.parse(kyp);
  var iv = CryptoJS.enc.Utf8.parse(kyp);
   var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(number), key,
          {
              keySize: 128 / 8,
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
          });
      return encrypted.toString();
  
}


export const GetCorridorState = (rxOrder) =>{

  if(rxOrder.lensTypes.length > 0 && rxOrder.selectedLensTypeId > 0){
    if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString())){
      if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString()).Name.toLowerCase().includes("progressive")){
        return false;
      }
    }
  }
  return true;
}

export const GetAddState = (rxOrder) =>{

  if(rxOrder.lensTypes.length > 0 && rxOrder.selectedLensTypeId > 0){
    if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString())){
      if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString()).Name.toLowerCase().includes("single vision") 
      ){
        return true;
      }
    }
  }

  if(rxOrder.lensDesignTypes.length > 0 && rxOrder.selectedLensDesignTypeId > 0){
    if(rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString())){
      if(rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString()).Name.toLowerCase().includes("myopia control") ||
          rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString()).Name.toLowerCase().includes("super kid")
      ){
        return true;
      }
    }
  }
  return false;
}

export const IsRightAddValid = (rxOrder) =>{

 
  if(rxOrder.lensTypes.length > 0 && rxOrder.selectedLensTypeId > 0 && rxOrder.RSPH !== null && rxOrder.RSPH.length > 0 && rxOrder.RADD !== null ){
    if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString())){
      var foundLensType = rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString()).Name.toLowerCase();
      if(foundLensType === "monofocal" || foundLensType === "single vision" ){
       // console.log("IsRightAddValid2");
        return false;
      }
    }
  }

  if(rxOrder.lensTypes.length > 0 && rxOrder.selectedLensTypeId > 0 && rxOrder.lensDesignTypes.length > 0 && rxOrder.selectedLensDesignTypeId > 0 && rxOrder.RSPH !== null && rxOrder.RSPH.length > 0 && rxOrder.RADD === null ){
    if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString())){
      if(rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString())){
        var foundLensType = rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString()).Name.toLowerCase();
        var foundDesignType = rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString()).Name.toLowerCase();
        if (foundLensType == "progressive" || foundLensType == "bifocal" || foundLensType == "lifestyle") {
          if(foundDesignType !== "unimax" && foundDesignType !== "unimax sport" && foundDesignType !== "lecta" && foundDesignType !== "myopia control" && foundDesignType !== "super kid"){
          //  console.log("IsRightAddValid1");
            return false;
          }
        }
    }
  }
  }
  
  //console.log("IsRightAddValid3");
  return true;

}

export const IsLeftAddValid = (rxOrder) =>{

 
  if(rxOrder.lensTypes.length > 0 && rxOrder.selectedLensTypeId > 0 && rxOrder.LSPH !== null && rxOrder.LSPH.length > 0 && rxOrder.LADD !== null ){
    if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString())){
      var foundLensType = rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString()).Name.toLowerCase();
      if(foundLensType === "monofocal" || foundLensType === "single vision" ){
      //  console.log("IsLeftAddValid2");
        return false;
      }
    }
  }

  if(rxOrder.lensTypes.length > 0 && rxOrder.selectedLensTypeId > 0 && rxOrder.lensDesignTypes.length > 0 && rxOrder.selectedLensDesignTypeId > 0 && rxOrder.LSPH !== null && rxOrder.LSPH.length > 0 && rxOrder.LADD === null ){
      if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString())){
        if(rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString())){
          var foundLensType = rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString()).Name.toLowerCase();
          var foundDesignType = rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString()).Name.toLowerCase();
          if (foundLensType == "progressive" || foundLensType == "bifocal" || foundLensType == "lifestyle") {
            if(foundDesignType !== "unimax" && foundDesignType !== "unimax sport" && foundDesignType !== "lecta" && foundDesignType !== "myopia control" && foundDesignType !== "super kid"){
              console.log("IsLeftAddValid1");
              return false;
            }
          }
      }
    }
  }
  
  //console.log("IsLeftAddValid3");
  return true;

}

export const IsColoringTypeValid = (rxOrder) =>{

 
  if(rxOrder.lensMaterialTypes.length > 0 && rxOrder.selectedLensMaterialTypeId > 0 && rxOrder.selectedColoringType === null){
    if(rxOrder.lensMaterialTypes.find(r => r.Value === rxOrder.selectedLensMaterialTypeId.toString())){
      var foundMAterialType = rxOrder.lensMaterialTypes.find(r => r.Value === rxOrder.selectedLensMaterialTypeId.toString()).Name.toLowerCase();
      if(foundMAterialType === "colour" || foundMAterialType === "color"){
        return false;
      }
    }
  }

  return true;

}


export const IsRXOrderValidForPreview = (rxOrder) => {
  if(
    (rxOrder.selectedCoatingId == null)
    ||
    ((rxOrder.LSPH !== null && (rxOrder.LCYL !== "0.00" && rxOrder.LCYL !== "" && rxOrder.LCYL !== null) && (rxOrder.LAXIS === "" || rxOrder.LAXIS === null || rxOrder.LAXIS < 0 || rxOrder.LAXIS > 180)))
    ||
    (!IsLeftAddValid(rxOrder))
    ||
    (rxOrder.LPrism !== null && rxOrder.LBaseOfPrism === null)
    ||
    ((rxOrder.RSPH !== null && (rxOrder.RCYL !== "0.00" && rxOrder.RCYL !== "" && rxOrder.RCYL !== null) && (rxOrder.RAXIS === "" || rxOrder.RAXIS === null || rxOrder.RAXIS < 0 || rxOrder.RAXIS > 180)))
    ||
    (!IsRightAddValid(rxOrder))
    ||
    (rxOrder.RPrism !== null && rxOrder.RBaseOfPrism === null)
    ||
    (((rxOrder.RDIA === null) && (rxOrder.LDIA === null)) && rxOrder.HBOX === null)
    ||
    (((rxOrder.RDIA === null) && (rxOrder.LDIA === null)) && rxOrder.VBOX === null)
    ||
    ((rxOrder.RSPH !== null && (rxOrder.FITTINGR !== null && rxOrder.FITTINGR < 1)))
    ||
    ((rxOrder.LSPH !== null && (rxOrder.FITTINGL !== null && rxOrder.FITTINGL < 1)))
    ||
    ((rxOrder.PANTO !== null && (rxOrder.PANTO < -1 || rxOrder.PANTO > 30)))
    ||
    ((rxOrder.FFA !== null && (rxOrder.FFA < -1 || rxOrder.FFA > 30)))
    ||
    ((rxOrder.RSPH !== null && rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL !== null && rxOrder.IPDR === null))
    ||
    ((rxOrder.LSPH !== null && rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL !== null && rxOrder.IPDL === null))
    ||
    (rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.selectedFrameType === null)
    ||
    (rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.ED === null)
    ||
    (rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL === null)
    ||
    (!IsColoringTypeValid(rxOrder))
    ||
    (!(rxOrder.selectedColoringType === null || rxOrder.selectedColoringType.toString() === "3") && (rxOrder.selectedColor === null || rxOrder.selectedColor === ""))
    ||
    ((rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType === "1" && (rxOrder.colorRate === "" || rxOrder.colorRate === null || rxOrder.colorRate < 0 || rxOrder.colorRate > 100)))
    ||
    ((rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType === "2" && (rxOrder.colorRateTop === "" || rxOrder.colorRateTop === null || rxOrder.colorRateTop < 0 || rxOrder.colorRateTop > 100)))
    ||
    ((rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType === "2" && (rxOrder.colorRateBottom === "" || rxOrder.colorRateBottom === null || rxOrder.colorRateBottom < 0 || rxOrder.colorRateBottom > 100)))
    ||
    (((rxOrder.LSPH === null ) && (rxOrder.RSPH === null )) && rxOrder.selectedProductId > 0)
    ||
    (rxOrder.customerPortalUserId === "" || rxOrder.customerPortalUserId === undefined || rxOrder.customerPortalUserId === null)
    ||
    (rxOrder.RDC !== null && rxOrder.RPosition === null)
    ||
    (rxOrder.LDC !== null && rxOrder.LPosition === null)
  ){
    return false;
  }

  return true;
}
export const ValidateRXOrder = (rxOrder) =>{

  var foundMaterialType = '';
  var foundLensBrand = '';
  var foundLensType = '';
  var foundLensDesignType = '';
  var foundCoating = '';
  var foundExtraServices = '';
  var foundLensIndex = '';
  var foundColoringType = '';

  if(rxOrder.selectedExtraServices.length > 0){
    rxOrder.selectedExtraServices.map((item) => {
    //  console.log("ExtraService ITem");
      //console.log(item);
      var tmpExtraServiceTitle = "";
      if(rxOrder.ExtraServices.find(r => r.Value.toString() === item.id.toString())){
      //  console.log("found");
        tmpExtraServiceTitle = rxOrder.ExtraServices.find(r => r.Value.toString() === item.id.toString()).Name.toLowerCase();
        foundExtraServices += tmpExtraServiceTitle +";";
      }
    });
  }
  
  if(rxOrder.lensbrands.length > 0 && rxOrder.selectedLensBrandId > 0){
    if(rxOrder.lensbrands.find(r => r.Value === rxOrder.selectedLensBrandId.toString())){
      foundLensBrand = rxOrder.lensbrands.find(r => r.Value === rxOrder.selectedLensBrandId.toString()).Name.toLowerCase();
    }
  }
  if(rxOrder.coloringTypes.length > 0 && rxOrder.selectedColoringType > 0){
    if(rxOrder.coloringTypes.find(r => r.Value === rxOrder.selectedColoringType.toString())){
      foundColoringType = rxOrder.coloringTypes.find(r => r.Value === rxOrder.selectedColoringType.toString()).Name.toLowerCase();
    }
  }
  if(rxOrder.lensIndexes.length > 0 && rxOrder.selectedLensIndexId > 0){
    if(rxOrder.lensIndexes.find(r => r.Value === rxOrder.selectedLensIndexId.toString())){
      foundLensIndex = rxOrder.lensIndexes.find(r => r.Value === rxOrder.selectedLensIndexId.toString()).Name.toLowerCase();
    }
  }
  if(rxOrder.lensTypes.length > 0 && rxOrder.selectedLensTypeId > 0){
    if(rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString())){
      foundLensType = rxOrder.lensTypes.find(r => r.Value === rxOrder.selectedLensTypeId.toString()).Name.toLowerCase();
    }
  }
  if(rxOrder.lensDesignTypes.length > 0 && rxOrder.selectedLensDesignTypeId > 0){
    if(rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString())){
      foundLensDesignType = rxOrder.lensDesignTypes.find(r => r.Value === rxOrder.selectedLensDesignTypeId.toString()).Name.toLowerCase();
    }
  }
  if(rxOrder.lensMaterialTypes.length > 0 && rxOrder.selectedLensMaterialTypeId > 0){
    if(rxOrder.lensMaterialTypes.find(r => r.Value === rxOrder.selectedLensMaterialTypeId.toString())){
      foundMaterialType = rxOrder.lensMaterialTypes.find(r => r.Value === rxOrder.selectedLensMaterialTypeId.toString()).Name.toLowerCase();
    }
  }
  if(rxOrder.coatings.length > 0 && rxOrder.selectedCoatingId > 0){
    if(rxOrder.coatings.find(r => r.Value === rxOrder.selectedCoatingId.toString())){
      foundCoating = rxOrder.coatings.find(r => r.Value === rxOrder.selectedCoatingId.toString()).Name.toLowerCase();
    }
  }

  var lstErrors = [];

  console.log("foundDesignType", foundLensDesignType);
  if(foundLensDesignType.toLowerCase().includes("masterlux")){

    var sphrSign = -1;
    if (rxOrder.RSPHSign === "true") {
        sphrSign = 1;
        console.log("sphrSign", sphrSign);
    }
    var sphlSign = -1;
    if (rxOrder.LSPHSign === "true") {
        sphlSign = 1;
        console.log("sphlSign", sphlSign);
    }

    if (rxOrder.LSPH !== null && (rxOrder.LSPH * sphlSign) > -6){
        lstErrors.push('نوع طراحی Masterlux نمی تواند مقدار SPH کمتر از -6 بپذیرد ');
    }

    if (rxOrder.RSPH !== null && (rxOrder.RSPH * sphrSign) > -6){
        lstErrors.push('نوع طراحی Masterlux نمی تواند مقدار SPH کمتر از -6 بپذیرد ');
    }
  }


  if (
    (foundMaterialType !== "white")
    &&
    (foundCoating !== "" && foundCoating.toLocaleLowerCase().includes("energy blue + uv"))
  ) {
    lstErrors.push(' پوشش ENERGY BLUE +UV تنها برای متریال WHITE قابل استفاده است ');
  }


if (rxOrder.LSPH !== null && (rxOrder.LCYL !== "0.00" && rxOrder.LCYL !== "" && rxOrder.LCYL !== null) && (rxOrder.LAXIS === "" || rxOrder.LAXIS === null || rxOrder.LAXIS < 0 || rxOrder.LAXIS > 180))
  lstErrors.push(' در صورت تکمیل شدن CYL عدسی چپ باید AXIS چپ وارد شود ');

if (rxOrder.RSPH !== null && (rxOrder.RCYL !== "0.00" && rxOrder.RCYL !== "" && rxOrder.RCYL !== null) && (rxOrder.RAXIS === "" || rxOrder.RAXIS === null || rxOrder.RAXIS < 0 || rxOrder.RAXIS > 180))
    lstErrors.push(' در صورت تکمیل شدن CYL عدسی راست باید AXIS راست وارد شود ');

if (rxOrder.RSPH === null && rxOrder.LSPH === null)
    lstErrors.push('مقدار SPH برای عدسی چپ یا راست باید تعیین شود ');

if (rxOrder.RAXIS !== null && rxOrder.RDC !== null && rxOrder.RPosition !== null && rxOrder.RSPH === null)
  lstErrors.push(' مقدار SPH عدسی راست تعیین نشده است');

if (rxOrder.LAXIS !== null && rxOrder.LDC !== null && rxOrder.LPosition !== null && rxOrder.LSPH === null)
  lstErrors.push(' مقدار SPH عدسی چپ تعیین نشده است');

//if (rxOrder.RCYL === null && rxOrder.RSPH !== null)
 // lstErrors.push(' مقدار CYL عدسی راست تعیین نشده است');

//if (rxOrder.LCYL === null && rxOrder.LSPH !== null)
 // lstErrors.push(' مقدار CYL عدسی چپ تعیین نشده است');

if (rxOrder.FITTINGR !== null && rxOrder.RSPH === null)
  lstErrors.push('در صورت تعیین FITTING-R می بایست اطلاعات عدسی راست تعیین شود');

if (rxOrder.FITTINGL !== null && rxOrder.LSPH === null)
  lstErrors.push('در صورت تعیین FITTING-L می بایست اطلاعات عدسی چپ تعیین شود');

if ((rxOrder.LSPH !== null && rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL !== null && rxOrder.IPDL === null))
  lstErrors.push('می بایست فیلد IPDR وارد شود');

if ((rxOrder.RSPH !== null && rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL !== null && rxOrder.IPDR === null))
  lstErrors.push('می بایست فیلد IPDL وارد شود');

if (rxOrder.IPDR !== null && rxOrder.RSPH === null)
 lstErrors.push('در صورت تعیین IPD-R می بایست اطلاعات عدسی راست تعیین شود');

if (rxOrder.IPDL !== null && rxOrder.LSPH === null)
  lstErrors.push('در صورت تعیین IPD-L می بایست اطلاعات عدسی چپ تعیین شود');

if (rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.selectedFrameType === null)
  lstErrors.push('نوع فریم می بایست تعیین شود');

if (rxOrder.selectedBase === null) 
    lstErrors.push('Base می بایست تعیین شود');

if (rxOrder.selectedCoatingId === null) 
    lstErrors.push('پوشش پیش فرض می بایست تعیین شود');


if (rxOrder.RPrism !== null && rxOrder.RBaseOfPrism === null)
    lstErrors.push('در صورت انتخاب Prism می بایست Base Of Prsim انتخاب شود');


if (rxOrder.LPrism !== null && rxOrder.LBaseOfPrism === null)
    lstErrors.push('در صورت انتخاب Prism می بایست Base Of Prsim انتخاب شود');


if ((foundLensType == "progressive" || foundLensType == "bifocal" || foundLensType == "lifestyle")) {

if (rxOrder.RSPH != "" && rxOrder.RADD === "" && foundLensDesignType !== "unimax" && foundLensDesignType !== "unimax sport" && foundLensDesignType !== "lecta") {
        lstErrors.push(' فیلد ADDبرای چشم  راست اجباری است ');
    }
}

if ((foundLensType == "progressive" || foundLensType == "bifocal" || foundLensType == "lifestyle")) {
  if (rxOrder.LSPH != "" && rxOrder.LADD === "" && foundLensDesignType !== "unimax" && foundLensDesignType !== "unimax sport" && foundLensDesignType !== "lecta") {
        lstErrors.push(' فیلد ADDبرای چشم  چپ اجباری است ');
    }
}

//console.log("foundExtraServices");
//console.log(foundExtraServices);
//console.log(foundExtraServices.toLowerCase().indexOf("tools"));
if (rxOrder.RDIA !== null)
    if ((parseFloat(rxOrder.RDIA) > 39 && parseFloat(rxOrder.RDIA) < 50 && foundExtraServices.toLowerCase().indexOf("tools") < 0))
        lstErrors.push('به دلیل انتخاب DIAR می بایست خدمات TOOLS انتخاب شود');


if (rxOrder.RDIA !== null)
  if ((parseFloat(rxOrder.LDIA) > 39 && parseFloat(rxOrder.LDIA) < 50 && foundExtraServices.toLowerCase().indexOf("tools") < 0))
        lstErrors.push('به دلیل انتخاب DIAL می بایست خدمات TOOLS انتخاب شود');



if (foundMaterialType.indexOf("polarized") >= 0
    ||
    foundMaterialType.toLowerCase().indexOf("nupolar") >= 0
    ||
    foundMaterialType.toLowerCase().indexOf("polycarbonate") >= 0
    ||
    foundLensIndex.indexOf("1.59") >= 0
    ||
    foundLensIndex.indexOf("1.74") >= 0
    ||
    foundLensBrand.toLowerCase().indexOf("ronik") >= 0
    ) {

} else {

    if (foundColoringType === "gradual") {
        if (rxOrder.colorRateBottom === null || rxOrder.colorRateTop == null) {
            lstErrors.push('در صورت روش رنگ GRADUAL می بایست درصد رنگ بالا  پایین تعیین شود');
        }
        if (rxOrder.selectedColor == null) {
            lstErrors.push('رنگ انتخاب نشده است');
        }
    }
    else if (foundColoringType === "full") {
        if (rxOrder.selectedColor == null) {
            lstErrors.push('رنگ انتخاب نشده است');
        }
    }
}


if ((foundColoringType === "" || rxOrder.selectedColor == null)
    &&
    (rxOrder.colorRateTop !== null && rxOrder.colorRateBottom !== null || rxOrder.colorRate !== null))
{
    lstErrors.push('آیتم های مربوط به رنگ درست انتخاب نشده است');
}


if (
  foundLensBrand.indexOf("bifocal") >= 0
  &&
  foundMaterialType.indexOf("transition") < 0
  &&
  rxOrder.RDIA !== null
  &&
  parseFloat(rxOrder.RDIA) > 70
) {

    lstErrors.push('در صورت انتخاب لنز Bifocal و متریال Transition می بایست اندازه ی DIAR نهایتا ۷۰ باشد');
}


if (
    foundLensBrand.indexOf("bifocal") >= 0
    &&
    foundMaterialType.indexOf("transition") < 0
    &&
    rxOrder.LDIA !== null
    &&
    parseFloat(rxOrder.LDIA) > 70

) {
    lstErrors.push('در صورت انتخاب لنز Bifocal و متریال Transition می بایست اندازه ی DIAL نهایتا ۷۰ باشد');
}



if (
    rxOrder.LCYL !== null
    &&
    rxOrder.LDIA !== null
    &&
    foundLensIndex === "1.5"
    &&
    Math.abs(parseFloat(rxOrder.LCYL)) <= 5.5
    &&
    parseFloat(rxOrder.LDIA) > 78
) {
    lstErrors.push('با تنظیمات انجام شده DIAL باید نهایتا 78 باشد');
}

if (
  rxOrder.RCYL !== null
  &&
  rxOrder.RDIA !== null
  &&
  foundLensIndex === "1.5"
  &&
  Math.abs(parseFloat(rxOrder.RCYL)) <= 5.5
  &&
  parseFloat(rxOrder.RDIA) > 78
) {
  lstErrors.push('با تنظیمات انجام شده DIAR باید نهایتا 78 باشد');
}



if (
    rxOrder.LCYL !== null
    &&
    rxOrder.LDIA !== null
    &&
    foundLensIndex === "1.56"
    &&
    Math.abs(parseFloat(rxOrder.LCYL)) <= 6.5
    &&
    parseFloat(rxOrder.LDIA) > 78
) {

    lstErrors.push('با تنظیمات انجام شده DIAL باید نهایتا 78 باشد');
}



if (
  rxOrder.RCYL !== null
  &&
  rxOrder.RDIA !== null
    &&
    foundLensIndex === "1.56"
    &&
    Math.abs(parseFloat(rxOrder.RCYL)) <= 6.5
    &&
    parseFloat(rxOrder.RDIA) > 78
) {

    lstErrors.push('با تنظیمات انجام شده DIAR باید نهایتا 78 باشد');
}




if (
  rxOrder.LCYL !== null
  &&
  rxOrder.LDIA !== null
    &&
    foundLensIndex === "1.60"
    &&
    Math.abs(parseFloat(rxOrder.LCYL)) <= 7
    &&
    parseFloat(rxOrder.LDIA) > 75
) {

    lstErrors.push('با تنظیمات انجام شده DIAL باید نهایتا 75 باشد');
}



if (
  rxOrder.RCYL !== null
  &&
  rxOrder.RDIA !== null
    &&
    foundLensIndex === "1.60"
    &&
    Math.abs(parseFloat(rxOrder.RCYL)) <= 7
    &&
    parseFloat(rxOrder.RDIA) > 75
) {
    lstErrors.push('با تنظیمات انجام شده DIAR باید نهایتا 75 باشد');
}



if (
  rxOrder.LCYL !== null
  &&
  rxOrder.LDIA !== null
    &&
    (
        (
          foundLensIndex === "1.74"
            &&
            Math.abs(parseFloat(rxOrder.LCYL)) <= 10
        )
        ||
        (
          foundLensIndex === "1.67"
            &&
            Math.abs(parseFloat(rxOrder.LCYL)) <= 8.50
        )
    )
    &&
    parseFloat(rxOrder.LDIA) > 75
) {
    lstErrors.push('با تنظیمات انجام شده DIAL باید نهایتا 75 باشد');
}



if (
  rxOrder.RCYL !== null
  &&
  rxOrder.RDIA !== null
    &&
    (
        (
          foundLensIndex === "1.74"
            &&
            Math.abs(parseFloat(rxOrder.RCYL)) <= 10
        )
            ||
        (
          foundLensIndex === "1.67"
        &&
            Math.abs(parseFloat(rxOrder.RCYL)) <= 8.50
        )
    )
    &&
    parseFloat(rxOrder.RDIA) > 75
) {
    lstErrors.push('با تنظیمات انجام شده DIAR باید نهایتا 75 باشد');
}


if (
    foundMaterialType.indexOf("photo") > 0
    &&
    rxOrder.LDIA !== null
    &&
    parseFloat(rxOrder.LDIA) > 70
) {
    lstErrors.push('با متریال PHOTO DIAR باید نهایتا 70 باشد');
}


if (
  foundMaterialType.indexOf("photo") > 0
    &&
    rxOrder.RDIA !== null
    &&
    parseFloat(rxOrder.RDIA) > 70
) {
    lstErrors.push('با متریال PHOTO DIAR باید نهایتا 70 باشد');
}


if (rxOrder.DBL !== null && rxOrder.HBOX !== null && rxOrder.VBOX) {
    if (rxOrder.LSPH !== null) {
        if (rxOrder.IPDL === null) {
            lstErrors.push('به دلیل تکمیل شدن بخشی از ابعاد فریم فیلد IPDL باید تکمیل شود');
        }
    }
    if (rxOrder.RSPH !== null) {
        if (rxOrder.IPDR === null) {
            lstErrors.push('به دلیل تکمیل شدن بخشی از ابعاد فریم فیلد IPDR باید تکمیل شود');
        }
    }
}

if (rxOrder.LSPH !== null &&
    (foundLensIndex === "1.5" || foundLensIndex === "1.56")
    &&
    (
     foundMaterialType == "photochromic gray"
     ||
     foundMaterialType == "photochromic brown"
    )
    &&
    parseFloat(rxOrder.LDIA) > 70

) {
    lstErrors.push('حداکثر مقدار قابل انتخاب DIA برای عدسی شما 70 میلیمتر است');
}

if (rxOrder.RSPH !== null &&
    (
      foundLensIndex === "1.5" || foundLensIndex === "1.56"
    )
    &&
    (
      foundMaterialType == "photochromic gray"
        ||
      foundMaterialType == "photochromic brown" 
    )
    &&
    parseFloat(rxOrder.RDIA) > 70
) {
    lstErrors.push('حداکثر مقدار قابل انتخاب DIA برای عدسی شما 70 میلیمتر است');
}


if (rxOrder.DBL === null && rxOrder.HBOX === null && rxOrder.VBOX === null &&
    (rxOrder.RSPH !== null && rxOrder.RDIA === null)
) {
    lstErrors.push(' مقدار دیامتر و یا ابعاد فریم خود را وارد نمایید  ');
}

if (rxOrder.DBL === null && rxOrder.HBOX === null && rxOrder.VBOX === null &&
  (rxOrder.LSPH !== null && rxOrder.LDIA === null)
) {
    lstErrors.push(' مقدار دیامتر و یا ابعاد فریم خود را وارد نمایید  ');
}

if (rxOrder.DBL !== null &&  rxOrder.HBOX !== null && rxOrder.VBOX !== null &&
    (rxOrder.RSPH !== "" && rxOrder.IPDR === ""))
{
    lstErrors.push(' با توجه به تکمیل شدن ابعاد فریم می بایست IPDR تکمیل شود  ');
}

if (rxOrder.DBL !== null && rxOrder.HBOX !== null && rxOrder.VBOX !== null &&
  (rxOrder.LSPH !== "" && rxOrder.IPDL === ""))
{
    lstErrors.push(' با توجه به تکمیل شدن ابعاد فریم می بایست IPDL تکمیل شود  ');
}

if (foundLensIndex === "1.53") {
    if
      ( (foundColoringType != "" && foundColoringType != undefined)
        ||
          rxOrder.selectedColor !== null
        ||
          rxOrder.colorRateBottom !== null || rxOrder.colorRateTop !== null || rxOrder.colorRate !== null)
        {
        lstErrors.push('با ایندکس 1.53 امکان انتخاب خدمات رنگ نیست');
        }
}




if(rxOrder.emergencyLevel !== undefined && rxOrder.emergencyLevel === 2)
{
  if(foundCoating.toLocaleLowerCase().includes("mirror") || 
    foundCoating.toLocaleLowerCase().includes("achromatic") ||
    foundCoating.includes("ACHROMATIC") ||
    //foundCoating.toLocaleLowerCase().includes("contrast") || 
    (foundColoringType != "" && foundColoringType != undefined)
    ){
      lstErrors.push('برای پوشش انتخابی و یا خدمات رنگ امکان انتخاب گزینه فوری وجود ندارد');
    }
}




return lstErrors;

}


export const ValidateSTOrder = (stOrder) =>{

  var lstErrors = [];
  //if(stOrder.items <= 0){
  //  lstErrors.push('ثبت سفارش بدون آیتم امکان پذیر نیست');
  //}
  if(stOrder.items.some(r => r.Quantity <= 0)){
    lstErrors.push('در بین آیتم های انتخابی آیتمی با تعداد منفی یا صفر قرار دارد که مجاز نیست');
  }
  return lstErrors;

}